import React from "react";
import ForgotPasswordBody from "../components/forgot-password";
import SeoMeta from "../components/meta";

export default function ForgotPassword() {
  return (
    <>
      <SeoMeta title="Forgot Password | FameWheels" desc="" url="forgot-password" />
      <ForgotPasswordBody />
    </>
  );
}
